import { getApiVersion, http } from '../utils/domain'

const prefix = (appId) => {
  return `${getApiVersion()}/apps/${appId}/ucase_ext`
}

// 执行下一级节点的特殊节点
export const ucaseImplement = (appId, data) => {
  return http()
    .post(`${prefix(appId)}/implement`, data)
    .json()
}

export const getStageNextNodes = (appId, objectId, tbId, stageId) => {
  return http()
    .get(
      `${getApiVersion()}/apps/${appId}/stage/nextNodes?objectId=${objectId}&tbId=${tbId}&stageId=${stageId}`
    )
    .json()
}

// 获取节点id
export const getDataStageBinding = (appId, tbId) => {
  return http()
    .get(`${getApiVersion()}/apps/${appId}/dataStageBinding/tbs/${tbId}`)
    .json()
}

export const postStageNode = (appId, data) => {
  return http()
    .post(`${getApiVersion()}/apps/${appId}/ucase_ext/stageNodePass`, data)
    .json()
}

// 开启流程
export const postStartFlow = (appId, data) => {
  return http()
    .post(`${getApiVersion()}/apps/${appId}/ucase_ext/startOneFlow`, data)
    .json()
}
